import { ReactNode } from 'react';

export const TOGGLE_SECTION_BADGE_NEW = 'new';

export type ToggleSectionBadge = typeof TOGGLE_SECTION_BADGE_NEW;

export const TOGGLE_SECTION_SIZE_S = 's';
export const TOGGLE_SECTION_SIZE_L = 'l';

export type ToggleSectionSize = typeof TOGGLE_SECTION_SIZE_S | typeof TOGGLE_SECTION_SIZE_L;

export interface ToggleSectionProps {
  value: boolean;
  onChange: (next: boolean) => void;
  label: string;
  subLabel?: string;
  badge?: ToggleSectionBadge;
  disabled?: boolean;
  loading?: boolean;
  size?: ToggleSectionSize;
  children?: ReactNode;
  className?: string;
  dataTestId?: string;
}
